/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.routing

import systems.frictionless.impulse.rest.route.RootPath
import systems.frictionless.impulse.rest.route.UserPath

enum class Route(
    override val hash: String
) : Routable {
    Wizard("wizard"),
    ChangePassword(UserPath.ChangePassword.FRAGMENT),
    ForgotPassword("forgot_password"),
    Account("delete_account");

    fun toLink() = "#$hash"

    fun toDeepLink() = "?${RootPath.QUERY_STRING_KEY_DEEP_LINK_FRAGMENT}=$hash"

    companion object
}
